<template>
    <div>
      <div v-if="loaded">
      <b-card >
        <b-row><b-col><h3>{{ this.Type }} Calibration Review</h3></b-col></b-row>
        <b-row><b-col><h3>{{this.DeviceName}}</h3></b-col></b-row>
          <b-row><b-col><b>Calibration Date:</b> {{ this.myData[2].CalibrationDate }} </b-col>
          <b-col><b>Calibration Time:</b> {{ this.myData[2].CalibrationTime }} </b-col></b-row>
          <br/>
          <b-card-group deck>
            <b-card class="TwoWideRepeatDash" v-for="(id,idx) in this.ProbeArray" :key="idx" 
                    header-border-variant="info"
                    header-bg-variant="info"
                    header-text-variant="light">
                    <template #header>
                <b-row><b-col>Probe {{ id.ProbeNo }}</b-col></b-row></template>
           <hr/>
        <b-row><b-col><b>Probe Feed</b></b-col><b-col>{{ id.ProbeFeed }}</b-col></b-row>
        <b-row><b-col><b>Probe Position</b></b-col><b-col>{{ id.ProbePosition }}</b-col></b-row>
        <b-row><b-col><b>Probe Recirculatory</b></b-col><b-col>{{ id.ProbeRecirc}}</b-col></b-row>
        <b-row><b-col><b>Probe Tag</b></b-col><b-col><b-col>{{id.ProbeTag }}</b-col></b-col></b-row>
        <br/>
        <b-row><b-col><b>Calibration Temp</b></b-col><b-col>{{id.ProbeTemp}}&#8451;</b-col></b-row>
        <b-row><b-col><b>Calibration Flow</b></b-col><b-col>{{id.ProbeFlow}}</b-col></b-row>
        </b-card>     
        </b-card-group>
        </b-card>
        <b-row><b-col><b-button variant="outline-success" v-if="stepComplete == false" v-on:click="CompletePage()">Complete Calibration</b-button></b-col></b-row>
    </div>
    </div>
</template>

<script>
    export default {
      props:['DataPass','Type','ID'],
      data() {
      return {
        stepComplete: false,
        myData: [],
        Values:[],
        ProbeArray:[],
        DeviceName: "",
        loaded: false
      }
    },
    computed: {},
    components: {},
    methods:{
      CompletePage(){
        this.Values = this.myData
        this.$emit("PageComplete",2,this.Values);
        this.stepComplete = true;
      }
    },
    mounted(){
        this.myData = this.DataPass;
        this.ProbeArray = this.myData[3][0];
        this.DeviceName = this.myData[3][2];
      this.loaded = true
    }

    }
</script>

<style>
.TwoWideRepeatDash{
  min-width: 45%; max-width: 100%; margin-bottom: 1rem !important;
}
</style>